import { Badge, Progress } from "antd";
import { notCountProject } from "../types/initStore/initProject";
import { statusProjectType } from "../types/statusProject";
import { reduceSum } from "./operationMath";
import { checkConsumeSemaforo, truncateFloat } from "../helpers/generalHelper";
import { colorSemaforo } from "../types/schemesColors";

export const statusProjectTagsRender = (statusProject = "ACTIVO", hasComment = true) => {
	let badge = true;
	let color = "blue";
	if (statusProjectType.active === statusProject) {
		color = "green";
	}
	if (statusProjectType.pause === statusProject) {
		color = "#5B0754";
	}
	if (statusProjectType.concluid === statusProject) {
		badge = hasComment;
		color = "#46bdc6";
	}
	if (statusProjectType.cancel === statusProject) {
		color = "#999999";
	}
	let tagsStatus = (
		<Badge dot={!badge}>
			<div style={{ backgroundColor: color, height: "25px", width: "25px", borderRadius: "25px" }} />
		</Badge>
	);

	return tagsStatus;
};

const checkIfConsume = (consume = 0, status = statusProjectType.active) => {
	let color = "#ccc";
	let pauseStatus = false;
	let order = 0;
	const consumeNameColor = checkConsumeSemaforo(consume);
	const colorSelect = colorSemaforo.find((color) => color.name === consumeNameColor);
	if (colorSelect) {
		color = colorSelect.color;
		order = colorSelect.index;
	}
	if (statusProjectType.pause === status) {
		pauseStatus = true;
	}
	return { consumeNameColor, statusProject: { pause: pauseStatus }, color, order };
};

export const consumeProjectCount = (
	projects = [],
	filter = {
		status: [],
		leader: [],
		responsible: [],
		comercial: [],
	}
) => {
	let countProject = [
		{ id: "total", text: "Total", number: 0, color: "#000", order: -2 },
		{ id: "pause", text: "Pausa", number: 0, color: "#522276", order: -1 },
	];
	let projectsFilter = [];
	let arrayBudgetProject = [];
	let arrayHoursWork = [];
	let arrayHoursDiferent = [];
	const statusLength = filter.status.length > 0;
	const leaderLength = filter.leader.length > 0;
	const responsibleLength = filter.responsible.length > 0;
	const comercialLength = filter.comercial.length > 0;
	if (statusLength || leaderLength || responsibleLength || comercialLength) {
		projectsFilter = projects.filter((project) => {
			let haveLeader = false;
			let haveResponsible = false;
			let haveStatus = false;
			let haveComercial = false;
			project.leader.forEach((lead) => {
				if (filter.leader.includes(lead)) {
					haveLeader = true;
				}
			});
			project.responsible.forEach((resp) => {
				if (filter.responsible.includes(resp)) {
					haveResponsible = true;
				}
			});

			project.comercial.forEach((resp) => {
				if (filter.comercial.includes(resp)) {
					haveComercial = true;
				}
			});

			haveStatus = filter.status.includes(project.status);
			let comparativeFilter = [];

			if (statusLength) {
				comparativeFilter.push(haveStatus);
			}
			if (leaderLength) {
				comparativeFilter.push(haveLeader);
			}
			if (responsibleLength) {
				comparativeFilter.push(haveResponsible);
			}

			if (comercialLength) {
				comparativeFilter.push(haveComercial);
			}

			const isProjectFilter = comparativeFilter.every((filterPrject) => filterPrject);

			return isProjectFilter;
		});
	} else {
		projectsFilter = projects.map((project) => {
			return project;
		});
	}
	// counProject
	projectsFilter.forEach((project) => {
		const { consume, status, name, hoursdevelop, hrsWork, difference } = project;
		if (notCountProject.includes(name)) {
			return;
		}
		arrayBudgetProject.push(hoursdevelop);
		arrayHoursWork.push(hrsWork);
		arrayHoursDiferent.push(difference);
		countProject[0].number++;
		const {
			color,
			consumeNameColor,
			statusProject: { pause },
			order,
		} = checkIfConsume(consume, status);
		if (pause) {
			countProject[1].number++;
		}
		const indexCountProject = countProject.findIndex((count) => count.id === consumeNameColor);
		if (indexCountProject > -1) {
			countProject[indexCountProject].number++;
		} else {
			countProject.push({ id: consumeNameColor, text: consumeNameColor, number: 1, color: color, order });
		}
	});

	return {
		countProject: countProject.sort((a, b) => a.order - b.order),
		sumTotalTableProject: {
			hoursBudget: reduceSum(arrayBudgetProject),
			hoursWork: reduceSum(arrayHoursWork),
			hoursDiferent: reduceSum(arrayHoursDiferent),
		},
	};
};

export const colorConsumeTags = (consume = 0) => {
	let color = "blue";
	const colorName = checkConsumeSemaforo(consume);
	const colorSelect = colorSemaforo.find((color) => color.name === colorName);
	if (colorSelect) {
		color = colorSelect.color;
	}
	let tagsStatus = (
		<Progress
			type="circle"
			percent={consume}
			style={{
				marginRight: 4,
				fontSize: 1,
				padding: 10,
			}}
			size="3"
			strokeColor={color}
			width={60}
			strokeWidth={12}
			status="normal"
			format={() => {
				return <span className="text-[10px] text-black">{truncateFloat(consume)}%</span>;
			}}
		/>
	);
	return tagsStatus;
};

export const filterTableProjectClient = (projects = []) => {
	let leaderFilter = [];
	let responsibleFilter = [];
	let commercialFilter = [];
	projects.forEach(({ leader, responsible, comercial, ...rest }) => {
		comercial.forEach((com) => {
			if (!commercialFilter.includes(com)) {
				commercialFilter.push(com);
			}
		});

		leader.forEach((lead) => {
			if (!leaderFilter.includes(lead)) {
				leaderFilter.push(lead);
			}
		});

		responsible.forEach((resp) => {
			if (!responsibleFilter.includes(resp)) {
				responsibleFilter.push(resp);
			}
		});
	});
	return { leaderFilter, responsibleFilter, commercialFilter };
};
